import { resourceService } from "@libs/axios";
import { fetchListReportStudentModule, fetchReportStudentExamActivity, fetchReportStudentPracticeActivity, fetchStudentDashboardClassModuleStats, fetchDashboardStudentV2, exportDashboardCompletion, exportDashboardPracticeResults } from "@store/actions/studentDashboardAction";
import { setListStudentModule, setLoading, setExamDashboardData, setPracticeDashboardData, setClassModuleStats, setDashboardStudentV2, setExportCompletionLoading, setExportPracticeResultsLoading } from "@store/reducers/studentDashboardReducer";
import { put, call, takeLatest } from "redux-saga/effects";
import { ResponseType } from "@store/index";
import { toast } from "react-toastify";
import { checkXlsxBlob, triggerBlobDownload, XlsxBlobCheck } from "@utils/FileDownloadUtils";

const API_URL = process.env.REACT_APP_API_URL;

function* fetchListReportStudentModuleSaga(action: ReturnType<typeof fetchListReportStudentModule>) {
  try {
    yield put(setLoading(true));
    const response: ResponseType = yield call(resourceService.get, API_URL + '/api/report_student_modules/?page=1&page_size=50')
    if (response.status === 200) {
      yield put(setListStudentModule(response?.data))
      yield put(setLoading(false));
    }
  }
  catch (error) {
    console.error(error);
    yield put(setLoading(false));
  }
}

function* fetchReportStudentExamActivitySaga(action: ReturnType<typeof fetchReportStudentExamActivity>) {
  try {
    const {
      module_id,
      start_date,
      end_date
    } = action.payload;
    const response: ResponseType = yield call(resourceService.post, API_URL + '/api/report_student_exam_activity/', {
      module_id,
      start_date,
      end_date
    }
    )
    if (response.status === 200) {
      console.log(response.data)
      yield put(setExamDashboardData(response.data))
    }
  }
  catch (error) {
    console.error(error)
  }
}

function* fetchReportStudentPracticeActivitySaga(action: ReturnType<typeof fetchReportStudentPracticeActivity>) {
  try {
    yield put(setLoading(true));
    const {
      module_id,
      start_date,
      end_date,
      status
    } = action.payload;
    const response: ResponseType = yield call(resourceService.post, API_URL + '/api/report_student_practice_activity/', {
      module_id,
      start_date,
      end_date,
      status
    }
    )
    if (response.status === 200) {
      console.log(response.data)
      yield put(setPracticeDashboardData(response.data))
      yield put(setLoading(false));
    }
  }
  catch (error) {
    console.error(error)
    yield put(setLoading(false));
  }
}

function* fetchStudentDashboardClassModuleStatsSaga(action: ReturnType<typeof fetchStudentDashboardClassModuleStats>) {
  try {
    yield put(setLoading(true));
    const {
      class_id,
      from_date,
      to_date
    } = action.payload;
    const response: ResponseType = yield call(resourceService.get, API_URL + '/api/student_dashboard_class_module_stats/', {
      params: {
        class_id,
        from_date,
        to_date
      }
    })
    if (response.status === 200) {
      yield put(setClassModuleStats(response.data))
      yield put(setLoading(false));
    }
  }
  catch (error) {
    console.error(error)
    yield put(setLoading(false));
  }
}

function* fetchDashboardStudentV2Saga() {
  try {
    yield put(setLoading(true));
    const response: ResponseType = yield call(resourceService.get, API_URL + '/api/dashboard_student_v2/');
    if (response.status === 200) {
      yield put(setDashboardStudentV2(response.data));
    }
  } catch (error) {
    console.error(error);
    yield put(setDashboardStudentV2(null));
  } finally {
    yield put(setLoading(false));
  }
}

function* exportDashboardCompletionSaga() {
  try {
    yield put(setExportCompletionLoading(true));
    const response: ResponseType = yield call(resourceService.get, API_URL + '/api/dashboard_student_v2/export_completion/', {
      responseType: 'blob',
    });
    const check: XlsxBlobCheck = yield call(checkXlsxBlob, response.data);
    if (response.status === 200 && check.ok) {
      const contentDisposition = response.headers?.['content-disposition'];
      triggerBlobDownload(response.data, 'bao_cao_hoan_thanh_bai_tap.xlsx', contentDisposition);
    } else {
      const { message } = check;
      toast.error(message ? `Tải báo cáo hoàn thành bài tập thất bại: ${message}` : 'Tải báo cáo hoàn thành bài tập thất bại.');
    }
  } catch (error) {
    console.error(error);
    toast.error('Tải báo cáo hoàn thành bài tập thất bại.');
  } finally {
    yield put(setExportCompletionLoading(false));
  }
}

function* exportDashboardPracticeResultsSaga() {
  try {
    yield put(setExportPracticeResultsLoading(true));
    const response: ResponseType = yield call(resourceService.get, API_URL + '/api/dashboard_student_v2/export_practice_results/', {
      responseType: 'blob',
    });
    const check: XlsxBlobCheck = yield call(checkXlsxBlob, response.data);
    if (response.status === 200 && check.ok) {
      const contentDisposition = response.headers?.['content-disposition'];
      triggerBlobDownload(response.data, 'bao_cao_ket_qua_lam_bai.xlsx', contentDisposition);
    } else {
      const { message } = check;
      toast.error(message ? `Tải báo cáo kết quả làm bài thất bại: ${message}` : 'Tải báo cáo kết quả làm bài thất bại.');
    }
  } catch (error) {
    console.error(error);
    toast.error('Tải báo cáo kết quả làm bài thất bại.');
  } finally {
    yield put(setExportPracticeResultsLoading(false));
  }
}

export default function* studentDashboardSaga() {
  yield takeLatest(fetchListReportStudentModule, fetchListReportStudentModuleSaga)
  yield takeLatest(fetchReportStudentExamActivity, fetchReportStudentExamActivitySaga)
  yield takeLatest(fetchReportStudentPracticeActivity, fetchReportStudentPracticeActivitySaga)
  yield takeLatest(fetchStudentDashboardClassModuleStats, fetchStudentDashboardClassModuleStatsSaga)
  yield takeLatest(fetchDashboardStudentV2, fetchDashboardStudentV2Saga)
  yield takeLatest(exportDashboardCompletion, exportDashboardCompletionSaga)
  yield takeLatest(exportDashboardPracticeResults, exportDashboardPracticeResultsSaga)
} 